import { Component, Inject, OnInit } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { IssueSiteMessage } from '../../model/issue-site-message.model';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueModel } from '../../model/issue.model';
import { IssueService } from '../../service/issue.service';
@Component({
  selector: 'site-messages-dialog',
  templateUrl:
    'console/app-js/modules/issue/components/site-messages-dialog/site-messages-dialog.component.html'
})
export class SiteMessagesDialogComponent extends APIOperableComponent
  implements OnInit {
  title: String = 'Site Message';
  protected issueModel: IssueModel = new IssueModel();
  public issueSiteMessages: Array<IssueSiteMessage>;
  constructor(
    @Inject('currentIssueModel') currentIssueModel: IssueModel,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private activeDialogService: UIActiveDialogService,
    private issueService: IssueService
  ) {
    super(progressService, toastr, authService);
    this.issueModel = currentIssueModel;
  }
  ngOnInit(): void {
    this.getSiteMessages();
  }

  /**
   * Method to get messages for an Issue
   */
  protected getSiteMessages(): void {
    this.issueService
      .getSiteMessages(
        this.issueModel[0].id,
        this.issueModel[0].customerNumbers
      )
      .subscribe(
        (res: any) => {
          if (res) {
            if (res.length !== 0) {
              const results = res.map(siteMsg => {
                return {
                  city: siteMsg.city,
                  number: siteMsg.number,
                  state: siteMsg.state
                };
              });
              this.issueSiteMessages = [...results];
            }
          } else {
            this.onAPIError(IssueUIMessages.LOAD_ISSUE_SITE_MESSAGES);
          }
        },
        () => {
          this.onAPIError(IssueUIMessages.LOAD_ISSUE_SITE_MESSAGES);
        }
      );
  }
  onCancel(): void {
    this.activeDialogService.dismiss();
  }
}
